import { DependencyList, useEffect, useRef } from 'react';

export const useDidMountEffect = (func: () => void | (() => void), deps: DependencyList) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      return func();
    } else {
      didMount.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
